













































import { Component, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import { GetListByCode } from "@/api/configureDictionary";
import {
  GetKnowledgeList,
  DeleteKnowledge,
  KnowledgePush
} from "@/api/pdOutPatient/pdEducation/pdKnowledge";
import PdKnowledgeAdd from "./pdKnowledgeAdd.vue";
@Component({
  components: {
    PdKnowledgeAdd
  }
})
export default class PdKnowledge extends AbpBase {
  @Prop() patient: any;
  showAddKnowledge: boolean = false;
  loading: boolean = false;
  pdKnowledge: any = {};
  PushKnowledge: any = {};
  KnowledgeGroup: any[] = [];
  KnowledgeComponent: any = {};
  KnowledgeDetailedList: any[] = [];
  KnowledgeDetailed = [
    {
      title: "编号",
      key: "id",
      minWidth: 80
    },
    {
      title: "名称",
      key: "name",
      minWidth: 180
    },
    {
      title: "分类",
      key: "groupName",
      minWidth: 120
    },
    {
      title: "内容",
      key: "text",
      minWidth: 250
    },
    {
      title: "上传方式",
      key: "type",
      minWidth: 120
    },
    {
      title: "文件",
      key: "isUrlName",
      minWidth: 80,
      render: (h: any, p: any) => {
        return h("span", {}, p.row.fileList&&p.row.fileList.length>0?"有":"无");
      }
    },
    {
      title: "操作时间",
      key: "lastModificationTime",
      minWidth: 140,
      render: (h: any, p: any) => {
        return h("span", {}, this.formatDateTime(p.row.lastModificationTime));
      }
    },
    {
      title: "操作人",
      key: "userName",
      minWidth: 120
    },
    {
      title: "操作",
      key: "",
      minWidth: 120,
      render: (h: any, p: any) => {
        return h("div", [
          h("Button", {
            props: { type: "success", icon: "ios-create", size: "small" },
            style: { marginRight: "5px" },
            domProps: {
              title: "修改"
            },
            on: {
              click: () => {
                this.onKnowledgeUpdate(p.row);
              }
            }
          }),
          h("Button", {
            props: { type: "error", icon: "ios-trash", size: "small" },
            style: { marginRight: "5px" },
            domProps: {
              title: "删除"
            },
            on: {
              click: () => {
                this.onKnowledgeDelete(p.row.id);
              }
            }
          })
          /*           h("Button", {
            props: { type: "primary", icon: "ios-open", size: "small" },
            style: { marginRight: "5px" },
            domProps: {
              title: "宣教推荐"
            },
            on: {
              click: () => {
                this.onKnowledgePush(p.row);
              }
            }
          }) */
        ]);
      }
    }
  ];
  /*   @Watch("patient") */
  async getData() {
    this.loading = true;
    this.pdKnowledge = {};
    var res = await GetKnowledgeList(this.KnowledgeComponent);
    this.KnowledgeDetailedList = res.objects;
    this.loading = false;
  }
  onAddKnowledge() {
    this.pdKnowledge = {
      id: 0,
      status: true,
      type:"图片",
      fileList:[]
    };
    this.showAddKnowledge = true;
  }
  //新增宣教材料
  onAddPdKnowledgeOk() {
    this.loading = true;
    this.$refs.PdKnowledgeAdd.submitFrom();
    this.loading = false;
  }

  //删除宣教材料
  onKnowledgeDelete(id: any) {
    this.$confirm("确定要删除吗？", "提示").then(() => {
      this.loading = true;
      DeleteKnowledge(id).then(res => {
        this.getData();
      });
      this.loading = false;
    });
  }

  //修改宣教材料
  onKnowledgeUpdate(data: any) {
    this.pdKnowledge = data;
    this.showAddKnowledge = true;
  }
/*   async ColseDiag() {
    this.showAddKnowledge = false;
    await this.getData();
  } */

  //推送宣教材料
  onKnowledgePush(data: any) {
    this.loading = true;
    this.PushKnowledge = data;
    this.PushKnowledge.pD_Patient_ID = this.patient.pD_Patient_ID;
    this.PushKnowledge.pD_Record_ID = this.patient.pD_Record_ID;
    this.PushKnowledge.pD_Register_ID = this.patient.pD_Register_ID;
    KnowledgePush(this.PushKnowledge).then(res => {
      this.getData();
    });
    this.loading = false;
  }

  initDic() {
    GetListByCode({ input: "PD_Knowledge_Group" }).then(res => {
      this.KnowledgeGroup = res;
      this.KnowledgeComponent.group = -1;
    });
  }
  constructor() {
    super();
    this.initDic();
    this.getData();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdOutPatient/pdEducation/pdKnowledge/index.vue